import { LitElement, html, css } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import { Image } from '../Image/Image';
import { getMediaIcon } from './MediaIcons';
import { Text } from '../Text/Text';
import { CloseButton } from '../../../constants/chat-assets';

class ReplyBlock extends LitElement {
  static properties = {
    color: { type: String },
    fontSize: { type: String },
    textAlign: { type: String },
    fontWeight: { type: String },
    fontStyle: { type: String },
    backgroundColor: { type: String },
    borderColor: { type: String },
    borderWidth: { type: String },
    borderStyle: { type: String },
    borderRadius: { type: String },
    fontFamily: { type: String },
    width: { type: String },
    height: { type: String },
    display: { type: String },
    alignItems: { type: String },
    justifyContent: { type: String },
    padding: { type: String },
    messageBody: { type: String },
    senderName: { type: String },
    messageTime: { type: String },
    icon1: { type: Object },
    icon2: { type: Object },
    onIconClick: { type: Function },
    messageInfo: { type: Object },
  };

  static styles = css`
    * {
      box-sizing: border-box;
    }

    .reply-block-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap:10px;
    }
    .icon-container {
      display: flex;
      align-itms: center;
      justify-content: space-between;
      width: 100%;
    }

    .icon-container div {
      cursor: pointer;
    }

    .icon-container svg {
      cursor: pointer;
    }

    .reply-body{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-content: flex-start;
      align-items: flex-start;
      background: var(--bg-primary-color);
      padding: 10px;
      border-radius: 10px;
    }
    .message-body-container {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 10px 0px;
    }
    .message-body-container {
      display: -webkit-box;
      color:var(--text-outgoing-message);
      font-size: 14px;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .iconTile{
      display: flex;
      align-items: center;
      gap: 5px;
      }
  }
  `;
  constructor() {
    super();
    this.color = 'black';
    this.fontSize = '16px';
    this.textAlign = 'left';
    this.fontWeight = 'normal';
    this.fontStyle = 'normal';
    this.backgroundColor = 'transparent';
    this.borderColor = 'transparent';
    this.borderWidth = '';
    this.borderStyle = '';
    this.borderRadius = '4px';
    this.fontFamily = '';
    this.width = '';
    this.height = 'auto';
    this.padding = '';
    this.messageBody = '';
    this.senderName = '';
    this.messageTime = '';
    this.icon1 = null;
    this.icon2 = null;
    this.onIconClick = () => {};
    this.messageInfo = {};
  }

  render() {
    let messageContent = this.messageBody;

    // Check if the message is an attachment
    if (this.messageInfo?.attachments?.length > 0) {
      const attachment = this.messageInfo?.attachments?.[this.messageInfo.attachments.length - 1];
      const mimeType = attachment?.mimeType;

      const mediaType = mimeType?.startsWith('image/') ? 1 : mimeType?.startsWith('video/') ? 2 : mimeType?.startsWith('application/') ? 3 : mimeType?.startsWith('audio/') ? 4 : 0;

      // Define the media icon based on mediaType
      const icon = getMediaIcon(mediaType);

      // Define the label based on mediaType
      const label =
        mediaType === 1
          ? 'Image'
          : mediaType === 2
          ? 'Video'
          : mediaType === 4
          ? 'Audio'
          : mediaType === 3
          ? attachment?.name // For documents, show the document name
          : '';

      messageContent = mediaType > 0 ? html`<span class="iconTile">${icon} ${label}</span>` : html`📎 ${attachment?.name}</span>`; // For documents
    }

    return html`
      <div
        class="reply-block-container"
        style=${styleMap({
          color: this.color,
          fontSize: this.fontSize,
          textAlign: this.textAlign,
          fontWeight: this.fontWeight,
          fontStyle: this.fontStyle,
          backgroundColor: this.backgroundColor,
          borderColor: this.borderColor,
          borderWidth: this.borderWidth,
          borderStyle: this.borderStyle,
          borderRadius: this.borderRadius,
          fontFamily: this.fontFamily,
          width: this.width,
          height: this.height,
          alignItems: this.alignItems,
          justifyContent: this.justifyContent,
          display: this.display,
          padding: this.padding,
        })}
      >
        <div class="reply-body">
        <div>
            ${Text({
              content: this.senderName,
              fontSize: '14px',
              fontWeight: '600',
              color: 'var(--base-color)',
            })}
        </div>
          <div class="message-body-container">${messageContent}</div>
          </div>
          <div @click=${this.onIconClick} >
          <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z" fill="#0F0F0F"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z" fill="#0F0F0F"></path> </g></svg>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('reply-block', ReplyBlock);
